import BaseModelRequest from "../communicate/BaseModelRequest";

export default class CategoriesRequest extends BaseModelRequest {

  getModelName() {
    return 'categorie';
  }

  getCategories() {
    const url = this.getModelName() + '/items';
    return this.get(url)
  }

  getItemInCategory(data) {
    const url = `${this.getModelName()}/${data.id}?page=${data.page}&limit=${data.limit}`;
    return this.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/request/CategoriesRequest.js